import Graylog from 'components/domain/analytics/Graylog/Graylog';
import { useActiveMember } from 'hooks';
import { useCallback, useMemo } from 'react';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';

function useCompanyNavMenuAnalytics() {
  const member = useActiveMember();

  const recordMyAccountClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.companyNavigationMenu.MY_ACCOUNT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordPreferencesClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.companyNavigationMenu.PREFERENCES,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordLogOutClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.companyNavigationMenu.LOG_OUT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordSwitchCompanyClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.companyNavigationMenu.SWITCH_COMPANY,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordLoginToAnotherCompanyClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.companyNavigationMenu.LOGIN_TO_ANOTHER_COMPANY,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  return useMemo(
    () => ({
      recordMyAccountClick,
      recordPreferencesClick,
      recordLogOutClick,
      recordSwitchCompanyClick,
      recordLoginToAnotherCompanyClick,
    }),
    [
      recordMyAccountClick,
      recordPreferencesClick,
      recordLogOutClick,
      recordSwitchCompanyClick,
      recordLoginToAnotherCompanyClick,
    ]
  );
}

export default useCompanyNavMenuAnalytics;
